"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseSpecialtyDto = instanceOfNurseSpecialtyDto;
exports.NurseSpecialtyDtoFromJSON = NurseSpecialtyDtoFromJSON;
exports.NurseSpecialtyDtoFromJSONTyped = NurseSpecialtyDtoFromJSONTyped;
exports.NurseSpecialtyDtoToJSON = NurseSpecialtyDtoToJSON;
exports.NurseSpecialtyDtoToJSONTyped = NurseSpecialtyDtoToJSONTyped;
const AssessmentStatus_1 = require("./AssessmentStatus");
const CertificationStatus_1 = require("./CertificationStatus");
/**
 * Check if a given object implements the NurseSpecialtyDto interface.
 */
function instanceOfNurseSpecialtyDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('assessmentStatus' in value) || value['assessmentStatus'] === undefined)
        return false;
    if (!('certificationStatus' in value) || value['certificationStatus'] === undefined)
        return false;
    if (!('assessmentIds' in value) || value['assessmentIds'] === undefined)
        return false;
    return true;
}
function NurseSpecialtyDtoFromJSON(json) {
    return NurseSpecialtyDtoFromJSONTyped(json, false);
}
function NurseSpecialtyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'name': json['name'],
        'assessmentStatus': (0, AssessmentStatus_1.AssessmentStatusFromJSON)(json['assessmentStatus']),
        'certificationStatus': (0, CertificationStatus_1.CertificationStatusFromJSON)(json['certificationStatus']),
        'assessmentIds': json['assessmentIds'],
        'assessmentAttemptExpiresAt': json['assessmentAttemptExpiresAt'] == null ? undefined : (new Date(json['assessmentAttemptExpiresAt'])),
    };
}
function NurseSpecialtyDtoToJSON(json) {
    return NurseSpecialtyDtoToJSONTyped(json, false);
}
function NurseSpecialtyDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'name': value['name'],
        'assessmentStatus': (0, AssessmentStatus_1.AssessmentStatusToJSON)(value['assessmentStatus']),
        'certificationStatus': (0, CertificationStatus_1.CertificationStatusToJSON)(value['certificationStatus']),
        'assessmentIds': value['assessmentIds'],
        'assessmentAttemptExpiresAt': value['assessmentAttemptExpiresAt'] == null ? undefined : ((value['assessmentAttemptExpiresAt']).toISOString()),
    };
}
//# sourceMappingURL=NurseSpecialtyDto.js.map